export default "__VITE_ASSET__k67$Y00U__"